import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { UserPreferenceSettingService } from '../../../api/services/user-preference-setting.service';
import { UserDefaultPage } from '../../../api/models';
import { UiPreferences } from '../../../api/models/ui-preferences';
interface MenuItem {
    key: keyof UiPreferences;
    label: string;
    order: number;
}

/*  Allowed UI preference keys */
const ALLOWED_UI_KEYS: (keyof UiPreferences)[] = [
    'problems',
    'allergies',
    'medications',
    'visits',
    'labs',
    'orders'
];

@Component({
    selector: 'app-user-preference-setting',
    templateUrl: './user-preference-setting.component.html'
})
export class UserPreferenceSettingComponent implements OnInit {

    frmUserPreferenceSetting!: FormGroup;
    isEdit = false;
    status: number = -1;

    userDefaultPageSeletedValue: number | null = null;
    selectedPageName = '';

    userDefaultPageOptions = [
        { key: UserDefaultPage.Dashboard, value: 'Dashboard' },
        { key: UserDefaultPage.Timeline, value: 'Timeline' }
    ];

    menus: MenuItem[] = [];


    showOrderList = true;

    constructor(
        private service: UserPreferenceSettingService,
        private messageService: MessageService,
        private confirmation: ConfirmationService,
    ) { }

    /* ---------------- INIT ---------------- */

    ngOnInit(): void {
        this.frmUserPreferenceSetting = new FormGroup({
            userDefaultPage: new FormControl(UserDefaultPage.Dashboard)
        });

        this.loadUserPreferences();
    }

    /* ---------------- LOAD ---------------- */

    loadUserPreferences(): void {
        this.service.userPreferenceSettingGetUserPreferenceSettings().subscribe(res => {

            if (!res) {
                this.loadDefaultMenus();
                return;
            }

            this.isEdit = true;

            this.frmUserPreferenceSetting.patchValue({
                userDefaultPage: res.userDefaultPage
            });

            this.userDefaultPageSeletedValue = res.userDefaultPage;
            this.status = res.userDefaultPage;
            this.updateSelectedPageName();

            if (res.uiPreferences) {
                this.mapUiPreferencesToMenus(res.uiPreferences);
            } else {
                this.loadDefaultMenus();
            }
        });
    }

    /* ---------------- MENU MAPPING ---------------- */

    mapUiPreferencesToMenus(prefs: UiPreferences): void {

        const updatedMenus: MenuItem[] = Object.entries(prefs)
            .filter(([key]) =>
                ALLOWED_UI_KEYS.includes(key as keyof UiPreferences)
            )
            .map(([key, value]) => ({
                key: key as keyof UiPreferences,
                label: this.toLabel(key),
                order: Number(value)
            }))
            .sort((a, b) => a.order - b.order);

        // Ensure missing keys
        const existingKeys = updatedMenus.map(m => m.key);
        ALLOWED_UI_KEYS.forEach(key => {
            if (!existingKeys.includes(key)) {
                updatedMenus.push({ key, label: this.toLabel(key), order: updatedMenus.length + 1 });
            }
        });


        this.showOrderList = false;
        this.menus = [...updatedMenus];

        setTimeout(() => {
            this.showOrderList = true;
        });
    }

    loadDefaultMenus(): void {
        this.showOrderList = false;

        this.menus = ALLOWED_UI_KEYS.map((key, index) => ({
            key,
            label: this.toLabel(key),
            order: index + 1
        }));

        setTimeout(() => {
            this.showOrderList = true;
        });
    }

    toLabel(key: string): string {
        return key
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, s => s.toUpperCase());
    }

    /* ---------------- SAVE ---------------- */

    onSubmit(): void {

        const uiPreferences: UiPreferences = {};
        this.menus.forEach(menu => {
            uiPreferences[menu.key] = menu.order.toString();
        });

        const payload = {       userDefaultPage: this.frmUserPreferenceSetting.value.userDefaultPage,   uiPreferences
        };

        this.service.userPreferenceSettingUpdateUserPreferenceSetting({
            actionType: this.isEdit ? 'Edit' : 'Add',
            practiceId: localStorage.getItem('EmrPracticeId')!,
            body: payload
        }).subscribe(() => {

            this.messageService.add({
                severity: 'success',
                summary: 'Saved',
                detail: 'User preferences saved successfully'
            });

            //  reload AFTER save
            this.loadUserPreferences();
        });
    }

    /* ---------------- UI HELPERS ---------------- */

    private updateSelectedPageName(): void {
        const option = this.userDefaultPageOptions
            .find(o => o.key === this.userDefaultPageSeletedValue);

        this.selectedPageName = option ? option.value : '';
    }

    trackByKey(index: number, item: MenuItem): string {
        return item.key;
    }

    


    onMenuReorder(): void {
        this.menus.forEach((menu, index) => {
            menu.order = index + 1;
        });
    }

    onReset() {
        this.confirmation.confirm({
            key: 'delete_confirmation',
            header: 'Reset to Default Settings',
            message: 'Are you sure you want to reset all user preferences to their default values?',
            acceptLabel: 'OK',
            rejectLabel: 'Cancel',        
            rejectVisible: true,         
            accept: () => {
                this.service
                    .userPreferenceSettingUpdateUserPreferenceSetting({
                        actionType: this.isEdit ? 'Edit' : 'Add',
                        practiceId: localStorage.getItem('EmrPracticeId')!,
                        body: { }
                    })
                    .subscribe((resp) => {
                        
                       
                    });
            },
            reject: () => {
               console.log('User cancelled Reset to default application settings ');
               
            }
        });
    }

    onCancel() {

    }
}

